import { FC } from 'react';

import { IconButton, IconButtonProps } from '@material-ui/core';

export type ApIconButtonProps = IconButtonProps;

const ApIconButton: FC<ApIconButtonProps> = (props) => {
  return <IconButton {...props} />;
};

export default ApIconButton;
